import Button from '@ixigo/iui/Button';
import { useState } from 'react';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import BookingCard from '../BookingCard';
import { BookingCardProps } from '../BookingCard/index.types';
import BottomsheetHeader from '../BottomsheetHeader';
import Dialog from '../Dialog';
import MessageBubble from '../MessageBubble';
import { WidgetProps } from './index.types';

export type BookingData = BookingCardProps['bookingData'] & { bookingId: string };

function BookingSelection({ isLastMessage, message, widgetData }: WidgetProps) {
    const { sendMessage } = useConversation();
    const { actor } = message;
    const data = widgetData.parameters.data as BookingData | BookingData[];
    const [viewAll, setViewAll] = useState(false);

    const selectTrip = (bookingData: BookingData) => {
        if (actor.type === ActorType.USER) return;

        const widget = {
            name: widgetData.name,
            parameters: {
                data: bookingData,
            },
        };
        const messageParts = [
            {
                isPrivate: false,
                widget,
            },
            {
                isPrivate: true,
                text: {
                    content: bookingData.bookingId,
                },
            },
        ];

        sendMessage({ messageParts, input: bookingData });
    };

    const renderBookingCard = (bookingData: BookingData) => (
        <BookingCard
            bookingData={bookingData as BookingCardProps['bookingData']}
            className={actor.type === ActorType.USER ? '' : 'cursor-pointer'}
            onClick={() => selectTrip(bookingData)}
        />
    );

    const renderBookingList = () => {
        const bookings = (data as BookingData[]) || [];

        return (
            <>
                {bookings.map(
                    (item, index) =>
                        index < 3 && (
                            <MessageBubble actor={actor} key={item.bookingId} className='!p-10'>
                                {renderBookingCard(item)}
                            </MessageBubble>
                        ),
                )}
                {bookings.length > 3 && (
                    // TODO: Remove button classname override
                    <Button
                        variant='outlined'
                        className='w-fit mt-5 !px-20 !py-[8px]'
                        onClick={() => setViewAll((prev) => !prev)}
                    >
                        View all trips
                    </Button>
                )}
                <Dialog open={viewAll} classes={{ container: '!min-w-full !max-h-[calc(100%-120px)]' }}>
                    <BottomsheetHeader title='Select your booking' onClose={() => setViewAll((prev) => !prev)} />
                    <div className='flex flex-col gap-15 p-20'>
                        {bookings.map((item) => (
                            <div className='p-10 shadow-100 rounded-20' key={item.bookingId}>
                                {renderBookingCard(item)}
                            </div>
                        ))}
                    </div>
                </Dialog>
            </>
        );
    };

    if (actor.type === ActorType.USER)
        return (
            <MessageBubble actor={actor} className='!p-10'>
                {renderBookingCard(data as BookingData)}
            </MessageBubble>
        );

    if (!isLastMessage) return null;

    return renderBookingList();
}

export default BookingSelection;
